const EventNames = {
  Mounted: 'cu:web_plugin:mounted'
};

// Expecting CustomEvent is polyfilled in plugins/index.html.erb
const createEvent = (name, option = {}) => window.dispatchEvent(new CustomEvent(name, option));

export const onMounted = () => createEvent(EventNames.Mounted);
